
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.7 29.7c-.5 0-1.1.1-1.5.4l-1.4.8c-.9-.7-1.9-1.1-3-1.3-.6-.1-1.2-.1-1.8 0l-.4-.3c-1.9-1.6-4.5-1.7-6.7-.4l-5.1 3.2c-.4-.2-.9-.5-1.4-.9l-2.1-1.5c-4.1-2.9-9.6-3.1-13.9-.6l-5.5 3.4 1.3 2.1 5.4-3.4c3.5-2.1 7.9-1.9 11.2.5l2.1 1.5c1.3.9 2.8 1.8 4.8 1.9l3.7.1c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.3 1.2h-7.6c-1.1 0-2.2-.2-3.2-.5l-1.9-.7-.8 2.4 1.9.7c1.3.4 2.7.7 4 .7h7.6c1.1 0 2-.4 2.7-1.1l11.2-6.7c.1 0 .2-.1.2-.1.4 0 .7.3.7.7 0 .5-.1.5-.2.6L28.1 44.5c-1.2.8-2.8.9-4.2.3l-9.8-4.1c-1.3-.6-2.9-.4-4.1.4l-3 1.8L8.3 45l3.1-1.9c.5-.3 1.2-.4 1.7-.2l9.8 4.1c.9.4 1.8.6 2.7.6 1.3 0 2.6-.4 3.8-1.1l17.1-10.9c.9-.6 1.4-1.5 1.4-2.7v-.1c0-1.7-1.4-3.1-3.2-3.1zm-5.3 2.7l-5.2 3.1c-.1-.5-.3-.9-.6-1.3l2.7-1.6c.9-.6 2.1-.6 3.1-.2zm-10.8.3l2.7-1.7c1-.6 2.1-.6 3-.2l-3.3 2h-.3l-2.1-.1zM14.3 21.6l1.8 1.8 8.4-8.4c1 1 2 1.8 3 2.6l-.3.3 1.8 1.8 8-8-1.8-1.8-.3.3c-.9-1.2-2-2.5-3.3-3.7C30.4 5.1 29.1 4 28 3.1l.3-.3L26.5 1l-8 8 1.8 1.8.3-.3c.7.8 1.4 1.7 2.2 2.6l-8.5 8.5zM26.2 4.9c1.2.9 2.5 2 3.7 3.3 1.3 1.3 2.4 2.5 3.3 3.7l-3.9 3.9c-1.2-.9-2.5-2-3.7-3.3-1.3-1.3-2.4-2.5-3.3-3.7l3.9-3.9z"}})])
          )
        }
      }
    